import $ from 'jquery';
import videojs from 'video.js';

import { KEY_ESCAPE, KEY_TAB } from 'bundles/videojs/plugins/keyboardConstants';

import _t from 'i18n!nls/videojs';

const HIGHLIGHT_CLASS = 'vjs-highlighted';
class CFullscreenToggle extends videojs.getComponent('FullscreenToggle') {
  constructor(player, options) {
    super(player, options);
    const label = _t('Full Screen');
    this.el_.innerHTML = '<span class="cif-2x cif-fw cif-expand"></span>';
    this.el_.innerHTML += `<span class="vjs-control-text">${label}</span>`;
    this.el_.setAttribute('aria-label', label);
    player.on('fullscreenchange', this.changeIcon.bind(this));
  }

  createEl() {
    const el = super.createEl();
    const $el = $(el);
    $el.attr('data-js', 'c-fullscreen-control');
    $el.removeAttr('title');
    $el.addClass('c-vjs-button c-video-control c-fullscreen-control');
    return el;
  }

  handleKeyPress(e) {
    const {
      settingsMenuButton: { menu },
    } = this.player_.controlBar;

    if (e.keyCode === KEY_TAB || e.keyCode === KEY_ESCAPE || (e.shiftKey && e.keyCode === KEY_TAB)) {
      $(menu.contentEl_).find('button').removeClass(HIGHLIGHT_CLASS);
      menu.unlockShowing();
    }
  }

  changeIcon() {
    const controlIcon = $(this.el_).find('span.cif-fw');

    if (this.player_.isFullscreen()) {
      controlIcon.removeClass('cif-expand');
      controlIcon.addClass('cif-compress');
    } else {
      controlIcon.removeClass('cif-compress');
      controlIcon.addClass('cif-expand');
    }
  }
}

videojs.registerComponent('CFullscreenToggle', CFullscreenToggle);
